import { legacy_createStore } from "redux";

const types = {
  SET_LOADING: "SET_LOADING",
};

const initialState = {
  loading: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_LOADING:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

const store = legacy_createStore(
  reducer,
  /* preloadedState, */ window.__REDUX_DEVTOOLS_EXTENSION__ &&
    window.__REDUX_DEVTOOLS_EXTENSION__()
);

function setLoading(loading = false) {
  store.dispatch({
    type:types.SET_LOADING,
    payload: {
      loading
    }
  });
}

const actions = {
  setLoading
};

export { store as default };
export { types, actions };
